import {
  ApiAppNamespaces,
  ApiBackofficeNamespaces,
  IQueuedRequest,
  OneAPIOptions
} from '../../common'
import { AppPaymentMethodsApi } from './app'
import { BackofficePaymentMethodsApi } from './backoffice'
import { Queue } from '../../queue'

export class PaymentsApp implements ApiAppNamespaces {
  app: AppPaymentMethodsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppPaymentMethodsApi(name, sessionId, requestsQueue, options)
  }

  invalidateAll() {
    this.app.invalidateAll()
  }
}

export class PaymentsBackoffice implements ApiBackofficeNamespaces {
  backoffice: BackofficePaymentMethodsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.backoffice = new BackofficePaymentMethodsApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.backoffice.invalidateAll()
  }
}
